import { render, staticRenderFns } from "./MeterMaintenanceWarnRecordList.vue?vue&type=template&id=8b06bba6&scoped=true"
import script from "./MeterMaintenanceWarnRecordList.vue?vue&type=script&lang=js"
export * from "./MeterMaintenanceWarnRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b06bba6",
  null
  
)

export default component.exports